import {
  projectLegacySidebarBottomLinks,
  projectLegacySidebarLinks,
} from '../navigation/workspaceNavigation'

// Keep the existing Sidebar contract stable while workspace navigation is migrated.
export const DASHBOARD_SIDEBAR_LINKS = projectLegacySidebarLinks()

export const DASHBOARD_SIDEBAR_BOTTOM_LINKS = projectLegacySidebarBottomLinks()
